webpackJsonp([1],{

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_style_scss__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_scss_style_scss__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
    }
});

/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7465fe56_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(55);
function injectStyle (ssrContext) {
  __webpack_require__(20)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7465fe56_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_twister_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e0412d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_twister_vue__ = __webpack_require__(54);
function injectStyle (ssrContext) {
  __webpack_require__(23)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e0412d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_twister_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e0412d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_twister_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 23:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('span',{staticClass:"players-display"},[_vm._v("Players: "+_vm._s(_vm.playersInGame)+"/"+_vm._s(_vm.playersSelected))]),_vm._v(" "),_c('button',{staticClass:"button--settings",on:{"click":function($event){_vm.settings = !_vm.settings}}},[_c('i',{staticClass:"fas fa-cog"}),_vm._v(" settings")]),_vm._v(" "),_c('div',{staticClass:"settings",class:{'settings--hidden' : !_vm.settings }},[_c('div',{staticClass:"players"},[_c('span',[_vm._v("Players: ")]),_vm._v(" "),_vm._l((_vm.playersOptions),function(count,index){return _c('label',{key:index,staticClass:"player",class:{ 'player--active': _vm.playerActive(count)}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.playersSelected),expression:"playersSelected"}],attrs:{"type":"radio","name":"players"},domProps:{"value":count,"checked":_vm._q(_vm.playersSelected,count)},on:{"change":function($event){_vm.playersSelected=count}}}),_vm._v("\n                "+_vm._s(count)+"\n            ")])})],2),_vm._v(" "),(_vm.lastMove && _vm.debug)?_c('div',[_c('p',[_vm._v("Currently playing: "+_vm._s(_vm.playersInGame)+" players")]),_vm._v(" "),_c('ul',_vm._l((_vm.extremities),function(placement,key){return (placement)?_c('li',{key:key},[_vm._v(_vm._s(key)+" on "),_c('span',{class:[placement]},[_vm._v(_vm._s(placement))])]):_vm._e()}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"action",class:{'action--faded': !_vm.action}},[(!_vm.lastMove)?[_vm._v(_vm._s(_vm.message))]:[_vm._v("Place "+_vm._s(_vm.lastExtremity)+" on "),_c('span',{staticClass:"color",class:_vm.lastColor},[_vm._v(_vm._s(_vm.lastColor))])],_vm._v(" "),(_vm.suddenDeath)?_c('div',[_vm._v("Sudden Death: Drop players!")]):_vm._e(),_vm._v(" "),(_vm.gameOver)?_c('div',[_vm._v("GAME OVER!")]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('button',{on:{"click":_vm.reset}},[_c('i',{staticClass:"fas fa-undo-alt"}),_vm._v(" restart")]),_vm._v(" "),_c('button',{attrs:{"disabled":!_vm.suddenDeath},on:{"click":_vm.removeUser}},[_c('i',{staticClass:"fas fa-user-times"}),_vm._v(" drop player")]),_vm._v(" "),_c('button',{staticClass:"button--twist",attrs:{"disabled":_vm.gameOver || _vm.suddenDeath},on:{"click":_vm.twist}},[_c('i',{staticClass:"far fa-compass"}),_vm._v(" twist")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main',[_c('twister')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 56:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_twister__ = __webpack_require__(22);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    components: {
        Twister: __WEBPACK_IMPORTED_MODULE_0__components_twister__["a" /* default */]
    }
});

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'twister',
    data: function data() {
        return {
            playersOptions: [2, 3, 4],
            playersSelected: 2,
            playersInGame: 2,
            settings: false,
            extremities: {
                'left hand': null,
                'right hand': null,
                'left foot': null,
                'right foot': null
            },
            colors: ['red', 'blue', 'green', 'yellow'],
            lastExtremity: false,
            lastColor: false,
            suddenDeath: false,
            gameOver: false,
            // action: true,
            lastStart: 0,
            debug: false
        };
    },

    computed: {
        message: function message() {
            return this.lastMove || 'get ready! (' + this.playersInGame + ' players)';
        },
        lastMove: function lastMove() {
            if (!this.lastExtremity || !this.lastColor) {
                return false;
            }
            return 'place ' + this.lastExtremity + ' on ' + this.lastColor;
        },
        action: function action() {
            return Date.now() - this.lastStart > 500;
        }
    },
    methods: {
        playerActive: function playerActive(player) {
            return this.playersInGame === player;
        },
        reset: function reset() {
            for (var extremity in this.extremities) {
                this.extremities[extremity] = null;
            }
            this.playersInGame = this.playersSelected;
            this.lastExtremity = false;
            this.lastColor = false;
            this.suddenDeath = false;
            this.gameOver = false;
        },
        twist: function twist() {
            var extremity = this.getRandomExtremity();
            var color = this.getRandomColor();

            this.placeIt(extremity, color);
        },
        placeIt: function placeIt(extremity, color) {
            if (this.isExtremityOnColor(extremity, color)) {
                console.log(extremity + ' already on ' + color);
                this.twist();
            } else if (!this.isColorFree(color)) {
                console.log('no more space on ' + color);
                this.lastExtremity = extremity;
                this.lastColor = color;
                this.extremities[extremity] = color;

                if (this.playersInGame > 2) {
                    this.suddenDeath = true;
                } else {
                    // this.gameOver = true;
                    this.twist();
                }
            } else {
                console.log('place ' + extremity + ' on ' + color);
                this.lastExtremity = extremity;
                this.lastColor = color;
                this.extremities[extremity] = color;
            }
        },
        removeUser: function removeUser() {
            if (this.playersInGame > 2) {
                this.playersInGame = this.playersInGame - 1;
                if (this.isColorFree(this.lastColor)) {
                    this.suddenDeath = false;
                }
            } else {
                this.gameOver = true;
            }
        },
        isExtremityOnColor: function isExtremityOnColor(extremity, color) {
            return this.extremities[extremity] === color;
        },
        isColorFree: function isColorFree(color) {
            var occurencies = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.extremities).filter(function (c) {
                return c === color;
            }).length;
            var fieldsUsed = occurencies * this.playersInGame;
            return 6 - fieldsUsed >= this.playersInGame;
        },
        fader: function fader() {
            var _this = this;

            this.action = false;
            setTimeout(function () {
                _this.action = true;
            }, 500);
        },
        getRandomExtremity: function getRandomExtremity() {
            var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.extremities);
            return keys[keys.length * Math.random() << 0];
        },
        getRandomColor: function getRandomColor() {
            return this.colors[Math.floor(Math.random() * this.colors.length)];
        }
    },
    watch: {
        playersSelected: function playersSelected() {
            this.reset();
        }
    }
});

/***/ })

},[14]);


// WEBPACK FOOTER //
// static/js/app.972118dac069d6f9dc92.js